import CrossSellItemsSFC from "./CrossSellItems.vue";
export const CrossSellItems = CrossSellItemsSFC;
